import { createAsyncThunk } from "@src/store/createAsyncThunk";
import { cancelDraft } from "@src/store/slices/experienceBuilder/common/thunks/cancelDraft";
import { trackModeToggled } from "@src/store/slices/experienceBuilder/common/thunks/mixPanel";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";
import { ExperienceBuilderMode } from "@src/store/slices/experienceBuilder/types";

export const setMode = createAsyncThunk<boolean, ExperienceBuilderMode>(
  "experienceBuilder/setMode",
  async (mode, { dispatch }) => {
    if (mode === "navigate") {
      const cancelled = await dispatch(cancelDraft()).unwrap();
      if (!cancelled) {
        return false;
      }
    }

    dispatch(experienceBuilderSlice.actions._setMode(mode));
    void dispatch(trackModeToggled({ toggledTo: mode }));

    return true;
  }
);
